import { ResponseService } from './response.service';
import { ApiService } from './api.service';
import { Injectable, Output } from '@angular/core';

@Injectable()
export class RegulationsService {
    private forRegulations: Boolean;
    private regulations: any;

    constructor(
        public apiService: ApiService,
        private responseService: ResponseService,
    ) { }

    clear() {
        this.forRegulations = false;
        this.regulations = [];
    }

    getRegulations() {
        return this.regulations;
    }

    needAccepting() {
        return this.forRegulations;
    }

    checkRegulations() {
        this.forRegulations = false;
        this.regulations = [];
        return this.apiService.get('/regulation/check').map((response) => {
            if (response.status.message === 'regulation.acceptance') {
                this.forRegulations = true;
                this.regulations = response.data.regulations;   
                return true;
            }
            this.forRegulations = false;
            this.regulations = [];
            return false;
        }, (error) => {
            this.responseService.error(error.json());
            this.forRegulations = false;
            this.regulations = [];
            return false;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/services/regulations.service.ts